import { PencilSquareIcon } from '@heroicons/react/24/outline';
import { ReactNode } from 'react';
import Button from '../button/Button';

interface Props {
  label: string;
  value?: ReactNode;
  onEdit?: () => void;
  readOnly?: boolean;
}

export function DetailField(props: Props) {
  const { label, value, onEdit, readOnly = false } = props;

  return (
    <div className="flex items-start justify-between gap-4 py-4">
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <span className="text-onlight-text-2 dark:text-ondark-text-2 text-sm">
          {label}
        </span>
        <span className="text-onlight-text-1 dark:text-ondark-text-1 text-sm [overflow-wrap:anywhere]">
          {value || '-'}
        </span>
      </div>
      {!readOnly && onEdit && (
        <Button variant="icon" onClick={onEdit} title={`Edit ${label}`}>
          <PencilSquareIcon className="h-5 w-5" aria-hidden="true" />
        </Button>
      )}
    </div>
  );
}

export default DetailField;
